import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Button } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-wrapper',
  standalone: true,
  imports: [Button, InputTextModule, FormsModule],
  templateUrl: './wrapper.component.html',
  styleUrls: ['./wrapper.component.scss']
})
export class WrapperComponent {
  @Input() header: string = '';
  @Input() buttonLabel: string = '';
  @Input() showControls: boolean = false;
  @Input() hasTableWrapper: boolean = false;
  @Input() siteHeaderData!: any;
  @Input() placeholder: string = '';
  @Output() buttonClick = new EventEmitter<void>();
  @Output() resetClicked = new EventEmitter<void>();
  private _searchText: string = '';

  @Input()
  get searchText(): string {
    return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.searchChanged.emit(this._searchText);
  }

  @Output() searchTextChange = new EventEmitter<string>();
  @Output() searchChanged = new EventEmitter<string>();

  onButtonClick() {
    this.buttonClick.emit();
  }

  onSearchInputChange(value: string) {
    this.searchTextChange.emit(value)
    this.searchChanged.emit(value);
  }
}
